"use client";

import { InlineSearchSelect } from "@/components/ui/inline-search-select";
import { useListNetworkMembers } from "@/lib/api/generated";
import { MAX_NETWORK_MEMBERS } from "../lib/filter";

/**
 * Pick team network members (Arbi users and people outside Arbi) by network
 * member id. Members removed since the search was saved show as "Removed
 * teammate" so they can be taken out.
 */
export function NetworkMembersSelect({
  value,
  onChange,
}: {
  value: string[];
  onChange: (memberIds: string[]) => void;
}) {
  const { data } = useListNetworkMembers();
  // Arbi users who never set anything up have no member row, so no paths to filter by.
  const members = (data?.items ?? []).flatMap((m) => (m.id ? [{ ...m, id: m.id }] : []));
  const known = new Set(members.map((m) => m.id));
  const options = [
    ...members.map((m) => ({
      value: m.id,
      label: m.kind === "external" ? `${m.name} (not in Arbi)` : m.name,
    })),
    // Until the list loads, nothing is known to be removed.
    ...(data ? value.filter((id) => !known.has(id)) : []).map((id) => ({
      value: id,
      label: "Removed teammate",
    })),
  ];
  return (
    <InlineSearchSelect
      multiple
      aria-label="Teammates"
      className="w-full"
      placeholder="Anyone on the team"
      options={options}
      value={value}
      onChange={(ids) => onChange(ids.slice(0, MAX_NETWORK_MEMBERS))}
    />
  );
}
